/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

export interface ContentCityShortTermRentalsProps {
  cityName: string;
}

export const ContentCityShortTermRentals = ({
  cityName,
}: ContentCityShortTermRentalsProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Short Term Rentals in ${cityName}, Netherlands`}
      </Typography>

      <Typography variant="body1" className={styles.paragraph}>
        {`Searching for short term rentals in ${cityName}? Look no further!
        Kamernet takes the hassle out of booking a short stay rental in 
        ${cityName}. As Netherlands’ leading platform, Kamernet specialises in
        short term accommodation in ${cityName} for students and traveling
        professionals. With short-term rentals starting from just 30 days, we
        offer unmatched flexibility for those seeking temporary housing in 
        ${cityName}. Whether you’re looking for short term apartments, short stay
        studios or rooms in ${cityName} for short term, Kamernet has it all.`}
      </Typography>

      <Typography variant="h3" className={styles.title}>
        {`Benefits of renting temporary housing in ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Renting temporary housing in ${cityName} offers unmatched flexibility
        and convenience. Short-term housings are ideal for students, travellers,
        or working professionals, allowing you to secure furnished
        accommodations without long-term commitments. Whether you’re staying for
        a few weeks or a few months, temporary housing in ${cityName} offers a
        comfortable and hassle-free way to experience the city.`}
      </Typography>

      <Typography variant="h3" className={styles.title}>
        {`Why rent a flat in ${cityName} for short term?`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`There are many reasons you might want to rent in ${cityName} for short
        term. Perhaps you’re in the city on a business trip, or maybe you’re
        studying in this beautiful Dutch capital. Alternatively, an apartment
        rental in ${cityName} for short term can feel more like home if you’re
        not a fan of hotels.`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`There are lots of benefits to choosing temporary housing in ${cityName}.
        When you rent an apartment in ${cityName} for short term, you have the
        freedom to stay in the neighbourhood you most prefer. It’s often
        significantly more affordable than booking a hotel for the same
        duration, especially for stays of a month or longer. Plus, short-term
        apartments typically offer far more space than a hotel room, along with
        access to everyday appliances and a wider range of facilities, giving
        you comfort and convenience that truly feels like home.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Why Kamernet?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`It is becoming increasingly popular to rent short term apartments in ${cityName}, 
        and thus, more competitive. However, this doesn’t mean that
        finding your ideal temporary housing in ${cityName} is difficult. Using
        a trustworthy platform like Kamernet makes finding a suitable short stay
        apartment simple and stress-free. Whether you’re looking for a 3 month
        rental or 6 month rental, our platform makes securing a short term
        rental in ${cityName} easier than ever. Rent a flat in ${cityName} for
        short term today and enjoy the comforts of home away from home.`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Tijdelijk Huren in ${cityName}, Nederland`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Ben je op zoek naar tijdelijk huren in ${cityName}? Zoek dan niet
        verder! Kamernet maakt het eenvoudig om een tijdelijke woning in 
        ${cityName} te vinden. Als het platform van Nederland, is Kamernet
        gespecialiseerd in tijdelijke huisvesting in ${cityName} voor studenten
        en werkende professionals. Met tijdelijke verhuur vanaf slechts 30 dagen
        bieden wij maximale flexibiliteit voor iedereen die tijdelijk wil wonen
        in ${cityName}. Of je nu op zoek bent naar een appartement, studio of
        kamer voor tijdelijk huren in ${cityName}, Kamernet heeft het allemaal.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        {`Voordelen van een Tijdelijke Woning Huren in ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Een tijdelijke woning huren in ${cityName} biedt gemak en flexibiliteit.
        Het is ideaal voor studenten, reizigers of professionals die een
        gemeubileerde woning zoeken zonder vast te zitten aan lange
        huurcontracten. Of je nu enkele weken of maanden blijft, tijdelijk wonen
        in ${cityName} is een comfortabele en zorgeloze manier om de stad te
        ervaren.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        {`Waarom Tijdelijk Huren in ${cityName}?`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Er zijn veel redenen om tijdelijk te huren in ${cityName}. Misschien
        verblijf je er voor werk, volg je een studie of wil je gewoon niet in
        een hotel verblijven. Een tijdelijk huis huren in ${cityName} voelt meer
        als thuis en geeft je de vrijheid om in je favoriete buurt te wonen.
        Bovendien is tijdelijk huren vaak voordeliger dan een hotel, zeker bij
        verblijven van een maand of langer. Tijdelijke appartementen bieden vaak
        meer ruimte dan een hotelkamer, en beschikken over handige voorzieningen
        zoals een keuken, wasmachine en snel internet. Dat maakt je verblijf een
        stuk aangenamer.`}
      </Typography>

      <Typography variant="h3" className={styles.title}>
        {`Vind Vandaag Nog een Tijdelijke Woning in ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Tijdelijke woningen in ${cityName} worden steeds populairder en dus ook
        gewilder. Toch hoeft het vinden van een geschikte tijdelijke woning geen
        uitdaging te zijn. Via een betrouwbaar platform zoals Kamernet is het
        eenvoudig en overzichtelijk. Of je nu zoekt naar een huurwoning voor 3
        maanden of 6 maanden, met Kamernet vind je snel en zonder gedoe wat je
        nodig hebt. Start vandaag nog met tijdelijk huren in ${cityName} en voel
        je thuis, waar je ook bent.`}
      </Typography>
    </React.Fragment>
  );
};
